export const GLOBAL_MESSAGE_LAST_UPDATED_KEY = 'LOCAL_STORAGE/GLOBAL_MESSAGE/LAST_UPDATED'
